import "@arco-design/web-react/es/Modal/style";
import _Modal from "@arco-design/web-react/es/Modal";
import React, { useEffect, useRef, useState, useCallback } from 'react';
import mermaid from 'mermaid';
mermaid.initialize({
  startOnLoad: false,
  theme: 'default',
  securityLevel: 'loose',
  flowchart: {
    useMaxWidth: true,
    htmlLabels: true,
    curve: 'basis'
  }
});
let renderCounter = 0;
export default function MermaidChart({
  chart,
  className
}) {
  const ref = useRef(null);
  const [preview, setPreview] = useState(false);
  const [previewSvg, setPreviewSvg] = useState('');

  // 内联渲染：使用 mermaid.render() 生成 SVG，避免 innerHTML 解析问题
  useEffect(() => {
    if (!ref.current) return;
    const id = `mermaid-inline-${++renderCounter}`;
    mermaid.render(id, chart).then(({
      svg
    }) => {
      if (ref.current) {
        ref.current.innerHTML = svg;
      }
    }).catch(err => {
      console.error('Mermaid inline render error:', err);
      if (ref.current) {
        ref.current.textContent = chart;
      }
    });
  }, [chart]);

  // 放大预览
  useEffect(() => {
    if (!preview) return;
    const id = `mermaid-preview-${++renderCounter}`;
    mermaid.render(id, chart).then(({
      svg
    }) => {
      setPreviewSvg(svg);
    }).catch(console.error);
  }, [preview, chart]);
  const handleClick = useCallback(() => {
    setPreview(true);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: className,
    onClick: handleClick,
    style: {
      cursor: 'pointer'
    },
    title: "\u70B9\u51FB\u653E\u5927\u9884\u89C8"
  }), /*#__PURE__*/React.createElement(_Modal, {
    title: null,
    visible: preview,
    onCancel: () => {
      setPreview(false);
      setPreviewSvg('');
    },
    footer: null,
    style: {
      width: '90vw',
      maxWidth: 1400
    },
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      overflowX: 'auto',
      padding: '16px 0'
    },
    dangerouslySetInnerHTML: {
      __html: previewSvg
    }
  })));
}